<template>
  <BaseCardV2
    titre="Rechercher un adhérent"
    :has-btn-action="false"
    class="card px-2"
  >
    <div class="d-flex flex-column align-center mt-10">
      <img
        width="160"
        height="126"
        src="@/assets/Illustration-accueil.png"
      >

      <div class="d-flex flex-column align-center my-5 mt-8">
        <span class="intro text-center">Nous sommes heureux de vous accueillir dans l'espace de pilotage des cultures.
        </span>
        <span class="intro text-center mx-8">En recherchant un adhérent qui vous est rattaché, vous découvrirez son tableau de bord (ses apports, ses contrats,...).</span>
        <span class="secondary--text mt-8 titre-h4">C'est un outil gratuit, accessible à tous.
        </span>
      </div>
    </div>
  </BaseCardV2>
</template>

<script>
import BaseCardV2 from '@/components/card/base-card-v2.vue'


export default {
  name: 'DecouverteConseiller',
  components: { BaseCardV2 },
}
</script>
